import { render, staticRenderFns } from "./ReporteCredito.vue?vue&type=template&id=05fb4753&scoped=true&lang=html&"
import script from "./ReporteCredito.vue?vue&type=script&lang=js&"
export * from "./ReporteCredito.vue?vue&type=script&lang=js&"
import style0 from "./ReporteCredito.vue?vue&type=style&index=0&id=05fb4753&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05fb4753",
  null
  
)

export default component.exports